import ReactDOM from 'react-dom'
// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'

// Apps
import {MetronicI18nProvider} from './_gori/i18n/Metronici18n'
/**
 * TIP: Replace this style import with dark styles to enable dark mode
 *
 * import './_gori/assets/sass/style.dark.scss'
 *
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_gori/assets/css/style.rtl.css'
 **/
import './../node_modules/select2-component/dist/select2.css'
import './../node_modules/bootstrap/dist/css/bootstrap.css'
import './../node_modules/bootstrap-daterangepicker/daterangepicker.css'
import './_gori/assets/sass/style.scss'
import './_gori/assets/sass/style.react.scss'
import './_gori/assets/sass/plugins.scss'
import {AppRoutes} from './app/routing/AppRoutes'
import {AuthProvider, setupAxios} from './app/modules/auth'
import {FeatureConfigProvider} from './_gori/helpers'
import 'react-toastify/dist/ReactToastify.css'

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */

/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
const queryClient = new QueryClient()

const initApp = async () => {
  await setupAxios(axios) // Wait for visitor ID to be set

  Chart.register(...registerables)

  ReactDOM.render(
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <FeatureConfigProvider>
          <MetronicI18nProvider>
            <AppRoutes />
          </MetronicI18nProvider>
        </FeatureConfigProvider>
      </AuthProvider>
    </QueryClientProvider>,
    document.getElementById('root')
  )
}

initApp()
